import { useEffect, useState } from "react";
import { Answer, Container, List, Question, QuestionWrapper } from "./Help.styles";
import styles from './Help.module.css';
import SectionTitle from "../../../Shared/SectionTitle/SectionTitle.component";

export default function Help() {
  const [question, setQuestion] = useState('');

  const questions = {
    COVERAGE: 'coverage',
    TIMER: 'timer',
    PAYMENT: 'payment',
    REPORT: 'report',
    VEHICLE_TYPE: 'vehicle-type'
  };

  const openAnswer = (questionItem) => {
    setQuestion(questionItem);
  };

  useEffect(() => {
    setQuestion('');

    window.addEventListener('click', function(e){   
      if (document.getElementById('questions-list') && !document.getElementById('questions-list').contains(e.target)){
        setQuestion('');
      }
    });
  }, []);

  return (
    <>
      <Container id="questions">
        <SectionTitle text="Precisando de ajuda?" />
        <List id="questions-list">
          <QuestionWrapper onClick={() => { openAnswer(questions.COVERAGE) }}>
            <Question>
              <span>O Infovist tem cobertura nacional?</span>
              <img
                src="images/help/arrow.png"
                height="15px"
                alt="arrow"
                className={(question === questions.COVERAGE) ? styles.opened : ''}
              />
            </Question>
            {(question === questions.COVERAGE) && (
              <Answer>
                Sim. Nosso WebApp cobre todos os estados e regiões do Brasil,
                <br/>é necessário apenas ter acesso a internet.
              </Answer>
            )}
          </QuestionWrapper>

          <QuestionWrapper onClick={() => { openAnswer(questions.TIMER) }}>
            <Question>
              <span>Em quanto tempo meu laudo é liberado após a finalização da vistoria?</span>
              <img
                src="images/help/arrow.png"
                height="15px"
                alt="arrow"
                className={(question === questions.TIMER) ? styles.opened : ''}
              />
            </Question>
            {(question === questions.TIMER) && (
              <Answer>
                Caso sua vistoria não tenha nenhuma restrição, será liberada em um prazo de até 24h contados a partir da finalização da vistoria.
                <br />Caso suas fotos não estejam adequadas você receberá um novo link pelo Whatsapp para refazer a vistoria e o prazo para envio do laudo será
                contado novamente a partir do envio das fotos. 
              </Answer>
            )}
          </QuestionWrapper>

          <QuestionWrapper onClick={() => { openAnswer(questions.PAYMENT) }}>
            <Question>
              <span>Quais bandeiras de cartão de crédito o Infovist aceita?</span>
              <img
                src="images/help/arrow.png"
                height="15px"
                alt="arrow"
                className={(question === questions.PAYMENT) ? styles.opened : ''}
              />
            </Question>
            {(question === questions.PAYMENT) && (
              <Answer>Aceitamos todas as bandeiras de cartão de crédito nacionais.</Answer>
            )}
          </QuestionWrapper>

          <QuestionWrapper onClick={() => { openAnswer(questions.VEHICLE_TYPE) }}>
            <Question>
              <span>Quais tipos de veículos o Infovist atende?</span>
              <img
                src="images/help/arrow.png"
                height="15px"
                alt="arrow"
                className={(question === questions.VEHICLE_TYPE) ? styles.opened : ''}
              />
            </Question>
            {(question === questions.VEHICLE_TYPE) && (
              <Answer>Nossa vistoria é feita apenas para carros e motos.</Answer>
            )}
          </QuestionWrapper>
        </List>
      </Container>
    </>
  )
}
